const LinksMovidesk = {
  CENTRA_DE_AJUDA: "https://ajuda.fortestecnologia.com.br/kb/pt-br/article/433200/fortes-bi",
  CHAT: "https://sites.google.com/fortestecnologia.com.br/chatpessoal-bi"
}

export default LinksMovidesk;